import EducationCategoryCodebookContainer from '@src/components/codebook/EducationCategoryCodebookContainer';
import React from 'react';

const AdminEducationCategoryCodebookPage = () => <EducationCategoryCodebookContainer />;

export default AdminEducationCategoryCodebookPage;
